module.exports = __webpack_public_path__ + "img/kid-profile.91d77d7d.svg";